import React, { useEffect, useState } from "react";
import { Plural } from "@lingui/macro";
import { Button } from "@silversea-ssc/ui-components-react";
import { FYCQuery } from "../../FindYourCruise/FYCQueryBuilder";
import { SearchClient } from "algoliasearch";

export interface SeeAllCruisesButtonProps {
  searchClient: SearchClient;
  initialSearchQuery: FYCQuery;
  defaultSearchIndexName: string;
  destinationName?: string;
  className?: string;
}

const SeeAllCruisesButton: React.FC<SeeAllCruisesButtonProps> = ({
  searchClient,
  initialSearchQuery,
  defaultSearchIndexName,
  destinationName,
  className = undefined
}) => {
  const [counter, setCounter] = useState<number>();

  useEffect(() => {
    searchClient
      .search([
        {
          indexName: defaultSearchIndexName,
          params: { filters: initialSearchQuery, hitsPerPage: 1 }
        }
      ])
      .then((data) => {
        setCounter(data.results[0].nbHits);
      });
  });

  return (
    <Button
      className={className}
      variant="secondary"
      centerText
      href="#find-your-cruise"
      data-content-piece="ANCHOR-SEE-ALL-CRUISES"
    >
      <Plural
        value={counter || 0}
        zero={`See all <0>${destinationName} Cruises</0>`}
        one={`See all # <0>${destinationName} Cruise</0>`}
        other={`See all # <0>${destinationName} Cruises</0>`}
        // eslint-disable-next-line jsx-a11y/heading-has-content
        components={[<h1 key="trans-0" />]}
      />
    </Button>
  );
};

export default SeeAllCruisesButton;
